// src/i18n.ts
import { createI18n } from 'vue-i18n'
import messages from '@intlify/unplugin-vue-i18n/messages'
import dayjs from 'dayjs'
import 'dayjs/locale/ko'

let currentLocale = globalThis.initOptions.locale

if (!currentLocale) {
  currentLocale = localStorage.getItem('lastLocale') ?? 'ko'
} else {
  localStorage.setItem('lastLocale', currentLocale)
}

dayjs.locale(currentLocale)

export const i18n = createI18n({
  locale: currentLocale,
  fallbackLocale: 'ko',
  silentTranslationWarn: true,
  missingWarn: false,
  fallbackWarn: false,
  silentFallbackWarn: true,
  globalInjection: true,
  messages
})

export default i18n
